<template>
  <div class="steps">
    <transition class="fade" name="fade" mode="out-in">
      <step-one :countriesOptions="countriesOptions" v-if="step === 1" />

      <step-two
        :country="country"
        :survey="survey"
        :getSurvey="getSurvey"
        v-if="step === 2"
      />
    </transition>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import StepOne from './StepOne.vue'
import StepTwo from './StepTwo.vue'

export default {
  props: {
    survey: {
      required: true,
    },

    getSurvey: {
      required: true,
    },
  },

  components: {
    StepOne,
    StepTwo,
  },

  data() {
    return {
      countriesOptions: [
        {
          value: 'AR',
          text: 'Argentina',
        },
        {
          value: 'BO',
          text: 'Bolivia',
        },
        {
          value: 'BR',
          text: 'Brazil',
        },
        {
          value: 'CL',
          text: 'Chile',
        },
        {
          value: 'CO',
          text: 'Colombia',
        },
        {
          value: 'CR',
          text: 'Costa Rica',
        },
        {
          value: 'DO',
          text: 'Dominican Republic',
        },
        {
          value: 'EC',
          text: 'Ecuador',
        },
        {
          value: 'SV',
          text: 'El Salvador',
        },
        {
          value: 'GT',
          text: 'Guatemala',
        },
        {
          value: 'HN',
          text: 'Honduras',
        },
        {
          value: 'MX',
          text: 'Mexico',
        },
        {
          value: 'NI',
          text: 'Nicaragua',
        },
        {
          value: 'PA',
          text: 'Panama',
        },
        {
          value: 'PY',
          text: 'Paraguay',
        },
        {
          value: 'PE',
          text: 'Peru',
        },
        {
          value: 'PR',
          text: 'Puerto Rico',
        },
        {
          value: 'ES',
          text: 'Spain',
        },
        {
          value: 'US',
          text: 'USA',
        },
        {
          value: 'UY',
          text: 'Uruguay',
        },
        {
          value: 'VE',
          text: 'Venezuela',
        },
      ],
    }
  },

  computed: {
    ...mapState(['step', 'country']),
  },

  methods: {
    ...mapActions(['setStep', 'setCountry']),
  },

  created() {
    if (this.survey.sample) {
      const country = this.countriesOptions.find(
        country => this.survey.sample.country === country.value,
      )

      this.setStep(2)

      this.setCountry(country)
    }
  },
}
</script>

<style lang="scss" scoped>
.steps {
  min-height: 60vh;
}
</style>
